import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './individual-all-product.action';
import { CommunityProduct } from '../../models/community-product.model';

export interface ErrorPayload {
  message: string;
  statusCode: number;
}

export interface ProductState {
  individualProducts: CommunityProduct[];
  loading: boolean;
  error: ErrorPayload | null;
}

export const initialState: ProductState = {
  individualProducts: [],
  loading: false,
  error: null,
};

export const individualProductReducer = createReducer(
  initialState,

  // When loading filtered products
  on(ProductActions.loadIndividualProducts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // On successful product load
  on(ProductActions.loadIndividualProductsSuccess, (state, { individualProducts }) => ({
    ...state,
    individualProducts,
    loading: false,
  })),

  // On failed product load
  on(ProductActions.loadIndividualProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
